"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint object-curly-newline: ["error", { "ObjectExpression": "always" }] */
const StyledButton = _styledComponents.default.button.withConfig({
  displayName: "ButtonLink__StyledButton",
  componentId: "design-system__sc-1dc9cve-0"
})(["font-family:", ";font-size:", ";line-height:", ";color:", ";cursor:pointer;text-decoration:none;border:none;text-align:left;background:none;&:hover{text-decoration:underline;}"], _BaseTheme.default.type.family.system, _BaseTheme.default.type.size.normal, _BaseTheme.default.type.lineHeight.regular, _BaseTheme.default.colors.blue);

const ButtonLink = _ref => {
  let {
    children,
    onClick
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(StyledButton, {
    type: "button",
    onClick: onClick
  }, children);
};

ButtonLink.propTypes = {
  children: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func
};
ButtonLink.defaultProps = {
  onClick: () => {}
};
var _default = ButtonLink;
exports.default = _default;